import { useAction } from "./useAction";
import { Empreendimento } from "../interfaces/Empreendimento";
import { cadastrarEmpreendimentoService } from "../services/cadastrarEmpreendimentoService";

export const useCadastrarEmpreendimento = () => {
  const {
    execute: cadastrarEmpreendimento,
    isLoading,
    data,
    error,
    success,
  } = useAction<Empreendimento>(cadastrarEmpreendimentoService);

  const handleSubmit = async (emprendimento: Empreendimento) => {
    try {
      const response = await cadastrarEmpreendimento(emprendimento);
      console.log("Empreendimento cadastrada com sucesso", response);
      return response;
    } catch (error) {
      console.error("Erro ao cadastrar emprendimento", error);
      throw error; // propaga erro para quem chamou
    }
  };

  return {
    handleSubmit,
    isLoading,
    data,
    error,
    success,
  };
};
